import {Checkbox} from "@mui/material";
import React from "react";

const TableRowSelection = ({selected, onSelect, item}) => {


    return (
        <Checkbox
            style={{padding: 0}}
            checked={selected}
            defaultChecked={selected}
            onChange={(e) => {
                onSelect(item, e);
            }}
        />
    )
}

export default TableRowSelection;
